<div
    class="mb-2 p-2 md:p-1 rounded cursor-pointer min-size-menu-item hover:bg-neutral3 w-full"
    [attr.data-testid]="'workspace-list-item-' + workspace.guid"
    (click)="selectWorkspace.emit(workspace)"
>
    <div class="flex items-center justify-between relative">
        <div class="flex">
            <app-tb-icon class="mr-2 icon-m" [style.color]="workspaceColor" [icon]="workspaceIcon">
            </app-tb-icon>
            <div class="flex gap-2 max-w-[11.5rem]">
                <span
                    class="text-ellipsis overflow-hidden"
                    [class]="isSelected ? 'max-w-[11rem]' : 'max-w-full'"
                >
                    {{ workspaceName }}
                </span>
                @if (isSelected) {
                    @if (showSelectedIcon) {
                        <ng-container *ngTemplateOutlet="selectedIcon"></ng-container>
                    } @else {
                        <app-tb-icon
                            class="h-full flex items-center text-primary icon-d"
                            icon="check"
                        ></app-tb-icon>
                    }
                }
            </div>
        </div>
        <div class="h-full">
            <app-tb-icon
                (click)="edit.emit(); $event.stopPropagation()"
                icon="custom_settings"
                [class]="showSettings ? 'visible' : 'visible md:invisible'"
                class="flex h-full items-center icon-d text-text"
            ></app-tb-icon>
        </div>
        <ng-template #selectedIcon>
            <app-tb-icon
                class="h-full flex items-center text-primary icon-m"
                icon="check"
            ></app-tb-icon>
        </ng-template>
    </div>
</div>
